import React from "react";
import PropTypes from "prop-types";
import ApplicantSectionWithTitle from "./ApplicantSectionWithTitle";
import { ProfileCodeChallengeList } from "components/Profile";

/**
 * ApplicantSkillsEvaluation
 *
 * @param {String} profileId
 */
const ApplicantSkillsEvaluation = ({ profileId }) => {
  return (
    <ApplicantSectionWithTitle titleMsgId="Missions.Applicants.ApplicantSkillsEvaluation.TechnicalAssessment">
      <ProfileCodeChallengeList profileId={profileId} />
    </ApplicantSectionWithTitle>
  );
};

ApplicantSkillsEvaluation.propTypes = {
  profileId: PropTypes.string.isRequired,
};

export default ApplicantSkillsEvaluation;
